var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 d-flex-inline align-items-between"},[_c('div'),_c('div',{staticClass:"float-right"},[_c('b-button',{attrs:{"variant":"primary"}},[_c('h3',{staticClass:"text-light"},[_vm._v(" Take Next Issue In Queue ")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }